import {servicesRoute} from './services'
import {company} from './company'
import { blog } from "./blog";
import { portfolio } from "./portfolio";
import NotFound from '../components/Basic/NotFound'
import Forge from '../components/CompanyPages/Forge/index.js'
import Configurator from '../components/DynamicContent/Configurator/index.jsx'
import PaymentTypes from '../components/CompanyPages/PaymentTypes'

import Main from '../components/DynamicContent/Main'

const routes = [
    {
        homepage: true,
        path: ["/en", "/ru", '/pl'] ,
        exact: true,
        component: Main,
    },
    ...servicesRoute,
    ...company,
    ...blog,
    ...portfolio,
    ...process,
    {
        exact: true,
        path: [
            `/en/forge`,
            `/ru/forge`,
            `/pl/forge`
             ],
        component: Forge,
    },
    {
        exact: true,
        path: [
            `/en/payments`,
            `/ru/payments`,
            `/pl/payments`
             ],
        component: PaymentTypes,
    },
    {
        exact: true,
        path: [
            `/en/configurate`,
            `/ru/configurate`,
            `/pl/configurate`
             ],
        component: Configurator,
    },
    {
        exact: false,
        path: '*',
        component: NotFound
    }
]

export default routes;


// WEBPACK FOOTER //
// ./src/routes/index.js